import { render, staticRenderFns } from "./SettingsOrganizerLogo.vue?vue&type=template&id=e6c41f82&"
import script from "./SettingsOrganizerLogo.vue?vue&type=script&lang=js&"
export * from "./SettingsOrganizerLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports